// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"521":"fa86195d22d050b93fca","559":"8354d2467e8ccea6b5ec","798":"a4b81c30b2ddb549defa"}[chunkId] + ".css";
};